// import React from 'react';
// import { MDBBtn } from 'mdbreact';

export const tableColumns = [
  {
    label: 'Name',
    field: 'customerName',
    sort: 'asc'
  },
  {
    label: 'Email ',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Phone Number',
    field: 'phoneNumber',
    sort: 'asc'
  },
  {
    label: 'Address',
    field: 'address',
    sort: 'asc'
  }
];
